import { useSelector } from 'react-redux'

import { selectStatusBanners } from 'redux/selectors/StatusBanner'

export const useStatusBanners = () => {
  return useSelector(selectStatusBanners)
}
